"use client";

import { useState } from "react";
import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import { routes } from "@/lib/routes";
import { Button } from "@/components/ui/button";

/**
 * Mappa Google Maps con caricamento su richiesta (click-to-load).
 * Finché la persona non preme il pulsante non parte nessuna richiesta verso
 * Google: l'iframe di google.com imposta cookie propri (NID, AEC, SOCS…) sul
 * visitatore appena si apre, quindi va caricato solo dopo una scelta esplicita
 * (linee guida Garante cookie 2021). Vedi decisions.md, 2026-10-15.
 */
export function MapEmbed({ src, title }: { src: string; title: string }) {
  const t = useTranslations("contatti");
  const [isLoaded, setIsLoaded] = useState(false);

  if (isLoaded) {
    return (
      <iframe
        src={src}
        title={title}
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
        className="size-full border-0"
      />
    );
  }

  return (
    <div className="flex size-full flex-col items-center justify-center gap-5 px-6 py-8 text-center">
      <p className="font-display text-[22px] leading-[1.3]">{t("mapPlaceholderTitle")}</p>
      <p className="max-w-[34ch] text-sm leading-[1.6] text-inchiostro/80">
        {t("mapPlaceholderNote")}{" "}
        <Link href={routes.cookie} className="border-b border-pietra-light hover:text-rosso-pozzo">
          {t("mapPlaceholderPolicy")}
        </Link>
      </p>
      <Button type="button" variant="secondary" onClick={() => setIsLoaded(true)}>
        {t("mapLoad")}
      </Button>
    </div>
  );
}
